import React from 'react'
import cx from 'classnames'
import withErrorBoundary from './ErrorBoundary'

import './Panel.css'

export function Panel ({ className, ...props }) {
  return (
    <div className={cx('Panel', className)} {...props} />
  )
}

export default Panel

export function PanelHeader ({ className, ...props }) {
  return (
    <div className={cx('PanelHeader', className)} {...props} />
  )
}

export function PanelHeader2 ({ className, children, ...props }) {
  return (
    <PanelHeader className={cx('PanelHeader2', className)} {...props}>
      <div children={children[0]} />
      <div children={children.slice(1)} />
    </PanelHeader>
  )
}

export function PanelHeader3 ({ className, children, ...props }) {
  return (
    <PanelHeader className={cx('PanelHeader3', className)} {...props}>
      <div children={children[0]} />
      <div children={children[1]} />
      <div children={children.slice(2)} />
    </PanelHeader>
  )
}

export const PanelContent = withErrorBoundary(function PanelContent ({ className, flex, ...props }) {
  return (
    <div className={cx('PanelContent', className, {
      'PanelContentFlex': !!flex
    })} {...props} />
  )
})

export function PanelSplitContent ({ className, ...props }) {
  return (
    <PanelContent className={cx('PanelSplitContent', className)} {...props} />
  )
}
export const PanelMain = withErrorBoundary(function PanelMain ({ className, ...props }) {
  return (
    <div className={cx('PanelMain', className)} {...props} />
  )
})

export const PanelSide = withErrorBoundary(function PanelSide ({ className, ...props }) {
  return (
    <div className={cx('PanelSide', className)} {...props} />
  )
})

export {
  Panel as Pane,
  PanelHeader as Header,
  PanelHeader2 as Header2,
  PanelHeader3 as Header3,
  PanelMain as Main,
  PanelSide as Side,
  PanelContent as Content,
  PanelSplitContent as SplitContent
}



// WEBPACK FOOTER //
// ./src/components/Panel.js